import { z } from 'zod';

export const offersResponseSchema = z.object({
  paymentFreeMonth: z
    .object({
      startDate: z.string(),
      nextRepaymentDate: z.string().optional(),
    })
    .optional(),
});
